import getConstrainedRadii from './get-constrained-radii';

const SVG_ARC_FLAGS = '0 0 1';

const createRoundedRectPath = ({ x, y, width, height, radii }) => {
  const {
    topLeft: { horizontal: tlH, vertical: tlV },
    topRight: { horizontal: trH, vertical: trV },
    bottomRight: { horizontal: brH, vertical: brV },
    bottomLeft: { horizontal: blH, vertical: blV },
  } = getConstrainedRadii(radii, width, height);

  const right = x + width;
  const bottom = y + height;

  const corners = {
    topLeft: { x: x + tlH, y: y + tlV },
    topRight: { x: x + width - trH, y: y + trV },
    bottomRight: { x: x + width - brH, y: y + height - brV },
    bottomLeft: { x: x + blH, y: y + height - blV },
  };

  return `
    M ${corners.topLeft.x} ${y}
    L ${corners.topRight.x} ${y}
    A ${trH} ${trV} ${SVG_ARC_FLAGS} ${right} ${corners.topRight.y}
    L ${right} ${corners.bottomRight.y}
    A ${brH} ${brV} ${SVG_ARC_FLAGS} ${corners.bottomRight.x} ${bottom}
    L ${corners.bottomLeft.x} ${bottom}
    A ${blH} ${blV} ${SVG_ARC_FLAGS} ${x} ${corners.bottomLeft.y}
    L ${x} ${corners.topLeft.y}
    A ${tlH} ${tlV} ${SVG_ARC_FLAGS} ${corners.topLeft.x} ${y}
    Z
  `
    .replace(/\s+/g, ' ')
    .trim();
};

export default createRoundedRectPath;
